/*========================================================================
* $Id: menu.js 98681 2017-06-06 13:22:57Z daniel.eppensteiner $
*
* Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2014
*
* Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
* Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
* Urheber festgelegten Stelle in der Funktion des Computerprogramms
* angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
* Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
* Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
* =========================================================================*/

define(
[
  "client/templates",
  "client/views/list",
  "!!raw-loader!../mustache/template.mustache",
  "underscore"
], function (
  Templates,
  ListView,
  DEFAULT_TEMPLATE,
  _
) {

  var TopMenu = ListView.extend({

    setModel: function () {
      ListView.prototype.setModel.apply(this, arguments);
      if (this.model) {
        this.listenTo(this.model, "reset", function () {
          var that = this;
          this.model.each(function (model) {
            that.addOne(model, model.collection);
          });
        });
      }
    },

    createEntryView: function (options) {
      options = _.clone(options);
      options.application = this.options.application;

      return this.options.node.children[0].template.createView(options);
    }

  });

  return Templates.add({
    name: "menu",
    view: TopMenu,

    attributes: {
      model: {
        name: "model",
        type: "string",
        defaultValue: "topMenu"
      }
    },

    content: {
      name: "template",
      type: "string"
    },

    default_template: DEFAULT_TEMPLATE && DEFAULT_TEMPLATE.default
  });

});
